import { useMemo, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

import { useAppError } from "hooks/useAppError";

export const AppErrorSnackbar = () => {
  const { currentError, clearError } = useAppError();
  const [showDetails, setShowDetails] = useState(false);

  const open = Boolean(currentError?.open);
  const title = currentError?.title || "Error";
  const message = currentError?.message || "Something went wrong.";
  const details = currentError?.details || "";
  const severity = currentError?.severity || "error";

  const actions = useMemo(() => {
    const items = [];

    if (details) {
      items.push(
        <Button
          key="details"
          color="inherit"
          size="small"
          onClick={() => setShowDetails((v) => !v)}
        >
          {showDetails ? "Hide details" : "Details"}
        </Button>,
      );
    }

    items.push(
      <Button key="close" color="inherit" size="small" onClick={clearError}>
        Close
      </Button>,
    );

    return items;
  }, [details, showDetails, clearError]);

  return (
    <Snackbar
      open={open}
      onClose={clearError}
      autoHideDuration={8000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={severity}
        onClose={clearError}
        action={actions}
        sx={{ width: "100%", maxWidth: 720 }}
      >
        <AlertTitle>{title}</AlertTitle>
        <Typography variant="body2">{message}</Typography>
        {details && (
          <Collapse in={showDetails}>
            <Typography
              variant="caption"
              sx={{ display: "block", mt: 1, opacity: 0.85 }}
            >
              {details}
            </Typography>
          </Collapse>
        )}
      </Alert>
    </Snackbar>
  );
};
